import { WallLateralDatumAnchorAll } from "building-types/datums/datumsTypes";
import { WallLayerType } from "building-types/walls/wallEnums";

/**
 * Utility for mapping WallLateralDatumAnchor to WallLayer.
 * @TODO - ultimately we should remove WallLateralDatumAnchor and replace with WallLayer for all usage, but
 * WallLayer is not stable enough so WallLateralDatum anchor is a reduced selection
 */

export const wallLateralDatumAnchorToWallLayer: {
  [K in WallLateralDatumAnchorAll]?: WallLayerType;
} = {
  [WallLateralDatumAnchorAll.OUTSIDE_FACE_OF_FRAMING]: WallLayerType.STRUCTURE,
  [WallLateralDatumAnchorAll.OUTSIDE_FACE_OF_SUBSTRATE]: WallLayerType.SUBSTRATE,
  [WallLateralDatumAnchorAll.OUTSIDE_FACE_OF_FINISH]: WallLayerType.FINISH,
  [WallLateralDatumAnchorAll.INSIDE_FACE_OF_FRAMING]: WallLayerType.STRUCTURE,
  [WallLateralDatumAnchorAll.INSIDE_FACE_OF_SUBSTRATE]: WallLayerType.SUBSTRATE,
  [WallLateralDatumAnchorAll.INSIDE_FACE_OF_FINISH]: WallLayerType.FINISH,
};
